import { render, staticRenderFns } from "./ViewOrderSummary.vue?vue&type=template&id=aff02eba"
import script from "./ViewOrderSummary.vue?vue&type=script&lang=js"
export * from "./ViewOrderSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports